import { LanguageService } from './language.service';

/**
 * Dynamic LOCALE_ID provider that reads the current locale from the LanguageService.
 * Extends String so Angular pipes (DatePipe, CurrencyPipe, etc.) resolve the locale
 * at formatting time rather than at injection time.
 *
 * **Pure Pipe limitation:** Angular's built-in pipes (DatePipe, CurrencyPipe) are pure
 * and only re-evaluate when their input value changes — not when LOCALE_ID changes.
 * A page reload is required after switching languages for locale-dependent pipes to
 * pick up the new locale. Both cloudfront and the designer enforce this via
 * `window.location.reload()` in their language-switch flows.
 *
 * **SSR:** During server-side rendering, `LanguageService.locale` starts with
 * `FRONTEND_DEFAULT_LANGUAGE` ('de-DE') and is updated once `setLanguageFromBackend()`
 * is called after the first CMS response. Since `toString()` is evaluated lazily,
 * pipes that render after the CMS call will use the correct locale.
 */
export class DynamicLocaleId extends String {
  constructor(private readonly languageService: LanguageService) {
    super();
  }

  override toString(): string {
    return this.languageService.locale();
  }

  override valueOf(): string {
    return this.toString();
  }
}
